import React from "react";
import { Row, Col, Modal, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import DeleteAddressHook from "../../hook/user/DeleteAddressHook";
import { useTranslation } from "react-i18next";

const UserAddressCard = ({ item }) => {
  const { t } = useTranslation()
  const [show, handleClose, handleShow, handleDelete] = DeleteAddressHook(item._id);
  
  return (
    <div className="p-3 bg-light rounded-3 border mb-3 font position-relative">
      
      {/* Delete Confirmation Modal */}
      <Modal show={show} onHide={handleClose}>
        <div className="border-0 shadow-sm font">
          <Modal.Header className="bg-light border-bottom-0 pb-0">
            <Modal.Title className="fw-bold fs-5 text-danger font">
              <i className="fa-solid fa-triangle-exclamation me-2"></i>
              {t("Confirm deletion")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="pt-4">
            <p className="text-muted mb-0 fw-bold">{t("Are you sure about the deletion process?")}</p>
          </Modal.Body>
          <Modal.Footer className="border-top-0 pt-3">
            <Button className="font px-4 py-2 fw-bold" variant="light" onClick={handleClose}>
              {t("retreat")}
            </Button>
            <Button className="font px-4 py-2 fw-bold" variant="danger" onClick={handleDelete}>
              {t("delete")}
            </Button>
          </Modal.Footer>
        </div>
      </Modal>

      <Row>
        {/* Address Info */}
        <Col sm={9} xs={8}>
          <div className="d-flex align-items-center mb-2">
            <i className="fa-solid fa-location-crosshairs text-primary me-2"></i>
            <strong className="text-dark fs-5">{item.name}</strong>
          </div>
          <div className="text-muted small fw-bold mb-2 ps-4" style={{ lineHeight: '1.6' }}>
            {item.address}
          </div>
          <div className="ps-4">
            <span className="text-muted small fw-bold me-2">{t("phone")}:</span>
            <span className="text-dark fw-bold" dir="ltr">{item.mobile}</span>
          </div>
        </Col>

        {/* Actions */}
        <Col sm={3} xs={4} className="d-flex justify-content-end align-items-start gap-2">
          <Link to={`/user/edit-address/${item._id}`} style={{ textDecoration: "none" }}>
            <button className="btn btn-sm btn-outline-primary fw-bold px-2 py-1" title={t("Modify")}>
              <i className="fa-solid fa-pen"></i>
            </button>
          </Link>
          <button className="btn btn-sm btn-outline-danger fw-bold px-2 py-1" onClick={handleShow} title={t("delete")}>
            <i className="fa-solid fa-trash-can"></i>
          </button>
        </Col>
      </Row>
    </div>
  );
};

export default UserAddressCard;
